<template lang='pug'>
  div(@click.prevent.stop='onClick')
    v-badge(@click.prevent.stop='onClick' color='primary' bottom overlap offset-x='15' offset-y='15' :content='badgeCount' :value='badgeCount')
      v-btn(text icon @click.prevent.stop='onClick').mr-1
        v-icon(:size='size') image
</template>

<script>
export default {
  name: 'BionicMetricsScreensButton',
  props: {
    size: {
      type: Number
    },
    test: {
      type: Object,
      required: true
    }
  },
  computed: {
    badgeCount() {
      if (!this.test || !this.test.screens || !this.test.screens.length) return 0;
      return this.test.screens.length + 1;
    }
  },
  methods: {
    onClick(evt) {
      this.$emit('click', evt);
    }
  }
};
</script>

<style scoped>

</style>
